import React, {Component} from 'react';
import { Card,  Button, Tooltip, Tag, TreeSelect} from 'antd';
import components from './../../../components';
import SelectInput from './../../../components/selectinput';
import layouts from '../../../layouts';
import services from '../../../services';
import Chart from '../../../components/Chart';
import utils from './../../../utils';
import AnalysisByTeacher from './AnalysisByTeacher';
import InfoByTeacher from './InfoByTeacher';
import RankingByTeacher from './RankingByTeacher';
import EarlyWaringByTeacher from './EarlyWaringByTeacher';

class HomeTeacher extends Component {
    constructor(props) {
        super(props);
        const session = JSON.parse(sessionStorage.session);

        const defaultKeywords = Object.assign({
            statType: 1,
            bgTermId: session.account.termId,
            bgTermName: session.account.termName,
            endTermId: session.account.termId,
            endTermName: session.account.termName,
        }, utils.getKeywords());
        this.state = {
            statistics: {
                "orgCount": 0,
                "majorCount": 0,
                "academicCount": 0,
                "teacherCount": 0,
                "classesCount": 0,
                "courseCount": 0,
                "studentCount": 0
            },
            analysis: {},
            todolist: [],
            courseData: [],
            keywords: defaultKeywords,
        }
        this.domain = defaultKeywords;
    }

    componentDidMount() {
        this.getStatistics();
        this.getTodoList();
    }

    handleSearchSubmit() {
        this.setState({
            keywords: Object.assign({}, this.domain, {v: Date.now(), pageNum: 1})
        });
    }

    handleChange(data) {
        this.domain = Object.assign({}, this.domain, data);
        this.setState({
            keywords: this.domain,
            domain: this.domain
        });

        utils.setKeywords(this.domain);
    }

    querySearchByCourse(value) {
        var params = {
            courseName: value,
            orgId: this.state.keywords.orgId,
            // employeeId: this.state.keywords.employeeId,
            limitFlag: true
        };

        return services.course.querySearchByName(params)
        .then((data) => {
            return data.map(item => {
                return {
                    value: item.value,
                    key: item.value,
                    label: item.label
                }
            }).slice(0,50);
        }).then(courseData => {
            this.setState({
                courseData
            })
        });
    }

    getStatistics() {
        services.home.home.statistics().then(statistics => {
            this.setState({
                statistics
            });
        });
    }

    getTodoList() {
        return services.home.home.todolist().then(todolist => {
            this.setState({
                todolist
            });
        })
    }

    getRadarOption() {
        return services.home.home.analysis().then(analysis => {
            const chart = {
                tooltip: {},

                radar: {
                    // shape: 'circle',
                    name: {
                        textStyle: {
                            color: '#fff',
                            backgroundColor: '#999',
                            borderRadius: 3,
                            padding: [3, 5]
                        }
                    },
                    center: ['50%', '55%'],
                    radius: 60,
                    indicator: []
                },
                series: [{
                    name: '指标分析',
                    type: 'radar',
                    // areaStyle: {normal: {}},
                    data : [
                        {
                            value : [],
                            name : '指标分析'
                        }
                    ]
                }]
            };

            if(analysis && analysis.length) {
                chart.radar.indicator = (analysis || []).map(item => (
                    { name: item.alias, max: 100}
                ));
    
                chart.series[0].data[0].value = (analysis || []).map(item => +(item.value));
                return chart;
            }

            
            return {};
        });
    }

    getPieOption() {
        return services.home.home.distribute().then(data => {
            const chart = {
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                series: [
                    {
                        name:'二级学院分析',
                        type:'pie',
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            emphasis: {
                                show: true,
                            }
                        },
                        labelLine: {
                            normal: {
                                show: true
                            }
                        },
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.1)'
                            }
                        },
                        data:[]
                    }
                ]
            };

            chart.series[0].data = (data || []).map(item => ({
                value: (item.value),
                name: item.category
            }));
            
            return chart;
        });
    }

    getBarOption() {
        return services.home.home.comparison().then(response => {
            var values = (response.data || []).map(item => ((+item.value) | 0));
            var minValue = response.meta.low || 0;
            var maxValue = response.meta.high || 0;

            const chart = {
                color: ['#3398DB'],
                tooltip : {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    top: '5',
                    bottom: '3%',
                    containLabel: true
                },
                calculable : true,
                xAxis : [
                    {
                        type : 'category',
                        data : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        min: minValue * .9,
                        max: maxValue + (100 - maxValue) * .2
                    }
                ],
                series : [
                    {
                        name:'直接访问',
                        type:'bar',
                        barWidth: '60%',
                        data:[10, 52, 200, 334, 390, 330, 220]
                    }
                ]
            };

            chart.xAxis[0].data = (response.data || []).map(item => item.category);
            chart.series[0].data = (response.data || []).map(item => ((+item.value) | 0));
            
            return chart;
        });
    }

    render() {
        const props = this.props;
        const { statistics, todolist, analysis } = this.state;
        return (
            <div className="site-card-border-less-wrapper">
                <Card bordered={false} style={{ width: '100%' }}>
                    <div className="root-panel" style={{ width: '100%' }}>
                        <layouts.Search classNames='2'>
                            <div className={this.state.toggble ? "root-search-wrapper search-toggle-open" : "root-search-wrapper"}>
                                <div className="search-item" >
                                    <div style={{float:'left'}}>
                                        <h3>基础信息</h3>
                                    </div>
                                    <div style={{textAlign:'right',marginRight:'5px'}}>
                                        <components.termType.Type value={this.state.keywords.statType}  style={{width: 160}} handleChange={this.handleChange.bind(this)} />
                                        {
                                            this.state.keywords.statType === 1?
                                            <components.term.Range bgTermId={this.state.keywords.bgTermId} endTermId={this.state.keywords.endTermId} style={{width: 160}} handleChange={this.handleChange.bind(this)} />
                                            :
                                            <components.term.Years bgTermId={this.state.keywords.bgTermId} endTermId={this.state.keywords.endTermId} style={{width: 160}} handleChange={this.handleChange.bind(this)} />
                                            
                                        }
                                    </div>
                                </div>
                            </div>
                        </layouts.Search>
                        <InfoByTeacher></InfoByTeacher>
                    </div>
                    <div className="root-panel" style={{ width: '100%' }}>
                        <AnalysisByTeacher></AnalysisByTeacher>
                    </div>
                    <div className="root-panel" style={{ width: '100%' }}>
                        <RankingByTeacher></RankingByTeacher>
                    </div>
                    <div className="root-panel" style={{ width: '100%' }}>
                        <EarlyWaringByTeacher></EarlyWaringByTeacher>
                    </div>
                    <div className="root-panel" style={{ width: '100%' }}>
                        <div className="root-panel-wrapper" style={{ width: '70%' }}>
                            <div className="root-panel-item">
                                <h4>指标分析  <a href="javascript:;">更多</a></h4>
                                <div className="root-panel-item-container">
                                    <div className="root-radar-wrapper">
                                    <div style={{textAlign: 'right'}}>
                                        部门：<components.home.Org type="all" value={this.state.keywords.orgName} style={{width: 160}} handleChange={this.handleChange.bind(this)} />
                                        &nbsp; &nbsp; 课程：<components.home.SelectInput 
                                            name="courseName"
                                            value={this.state.keywords.courseName}
                                            style={{width: 160}}
                                            search={true}
                                            onChange={(data) => {
                                                this.handleChange({
                                                    courseId: data.key,
                                                    courseName: data.label
                                                })
                                            }} 
                                            onSearch={(value) => {
                                                this.querySearchByCourse(value);
                                            }} 
                                            onFocus={(target) => {
                                                this.querySearchByCourse('');
                                            }}
                                            data={this.state.courseData} 
                                            />
                                            &nbsp; <Button shape="circle" icon="search" onClick={this.handleSearchSubmit.bind()}/>
                                    </div>
                                    <Chart setOption={this.getRadarOption.bind(this)}></Chart>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="root-panel-wrapper" style={{ width: '30%' }}>
                            <div className="root-panel-item">
                                <h4>二级学院分布</h4>
                                <div className="root-panel-item-container">
                                    <Chart setOption={this.getPieOption.bind(this)}></Chart>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="root-panel">
                        <div className="root-panel-wrapper">
                            <div className="root-panel-item">
                                <h4>指标分析</h4>
                                <div className="root-panel-item-container">
                                    <div className="root-radar-wrapper">
                                    <Chart setOption={this.getRadarOption.bind(this)}></Chart>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="root-panel-wrapper">
                            <div className="root-panel-item">
                                <h4>待办事项 <a href="javascript:;">更多</a></h4>
                                <div className="root-panel-item-container">
                                    <table>
                                        {
                                            todolist.map(row => (
                                                <tr>
                                                    <td>[{row.createDate}]</td>
                                                    <td><a href="javascript:;">{row.itemTitle}</a></td>
                                                </tr>
                                            ))
                                        }
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className="root-panel-wrapper">
                            <div className="root-panel-item">
                                <h4>二级学院分布</h4>
                                <div className="root-panel-item-container">
                                    <Chart setOption={this.getPieOption.bind(this)}></Chart>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
            // <layouts.ViewPort>
            //     <h1>教师质量中心</h1>
            //     <div className="home-cards">
            //         <div className="home-card">
            //             <i className="fa fa-graduation-cap" aria-hidden="true"></i>
            //             <span className="card-cound">{statistics.studentCount}</span>
            //             <label>学生数</label>
            //         </div>

            //         <div className="home-card">
            //             <i className="fa fa-sitemap" aria-hidden="true"></i>
            //             <span className="card-cound">{statistics.orgCount}</span>
            //             <label>部门数</label>
            //         </div>

            //         <div className="home-card">
            //             <i className="fa fa-university" aria-hidden="true"></i>
            //             <span className="card-cound">{statistics.academicCount}</span>
            //             <label>学院数</label>
            //         </div>

            //         <div className="home-card">
            //             <i className="fa fa-filter" aria-hidden="true"></i>
            //             <span className="card-cound">{statistics.majorCount}</span>
            //             <label>专业数</label>
            //         </div>

            //         <div className="home-card">
            //             <i className="fa fa-users" aria-hidden="true"></i>
            //             <span className="card-cound">{statistics.teacherCount}</span>
            //             <label>教师数</label>
            //         </div>

            //         <div className="home-card">
            //             <i className="fa fa-map-signs" aria-hidden="true"></i> 
            //             <span className="card-cound">{statistics.classesCount}</span>
            //             <label>班级数</label>
            //         </div>

            //         <div className="home-card">
            //             <i className="fa fa-file-text-o" aria-hidden="true"></i>
            //             <span className="card-cound">{statistics.courseCount}</span>
            //             <label>课程数</label>
            //         </div>
            //     </div>
            //     <div className="root-panel">
            //         <div className="root-panel-wrapper">
            //             <div className="root-panel-item">
            //                 <h4>指标分析</h4>
            //                 <div className="root-panel-item-container">
            //                     <div className="root-radar-wrapper">
            //                     <Chart setOption={this.getRadarOption.bind(this)}></Chart>
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>

            //         <div className="root-panel-wrapper">
            //             <div className="root-panel-item">
            //                 <h4>待办事项 <a href="javascript:;">更多</a></h4>
            //                 <div className="root-panel-item-container">
            //                     <table>
            //                         {
            //                             todolist.map(row => (
            //                                 <tr>
            //                                     <td>[{row.createDate}]</td>
            //                                     <td><a href="javascript:;">{row.itemTitle}</a></td>
            //                                 </tr>
            //                             ))
            //                         }
            //                     </table>
            //                 </div>
            //             </div>
            //         </div>

            //         <div className="root-panel-wrapper">
            //             <div className="root-panel-item">
            //                 <h4>二级学院分布</h4>
            //                 <div className="root-panel-item-container">
            //                     <Chart setOption={this.getPieOption.bind(this)}></Chart>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>

            //     <div className="root-panel">
            //         <div className="root-panel-org">
            //             <h4>部门评价分数对比</h4>
            //             <div className="root-panel-item-container">
            //                 <Chart setOption={this.getBarOption.bind(this)}></Chart>
            //             </div>
            //         </div>
            //     </div>
            // </layouts.ViewPort>
            
        );
    }
}

export default HomeTeacher;
